// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EeUEy","containerIntegrations":"styles_containerIntegrations__2RGmx","whiteBox":"styles_whiteBox__GMJ_m"};